import React, { useState, useEffect } from "react";
import { Button, Message } from "semantic-ui-react";
import { withState } from "react-searchkit";
import axios from "axios";

const axiosWithCSRF = axios.create({
  withCredentials: true,
  xsrfCookieName: "csrftoken",       // Must match your backend CSRF cookie name
  xsrfHeaderName: "X-CSRFToken",     // Header your backend expects
  headers: {
    "Content-Type": "application/json",
    Accept: "application/json",
  },
});

export const DownloadAllButtonCmp = ( {currentResultsState} ) => {
  const [isAuthenticated, setIsAuthenticated] = useState(false);
  const [downloading, setDownloading] = useState(false);

  useEffect(() => {
    const checkUser = async () => {
      try {
        const response = await fetch("/api/me", {
          method: "GET",
          headers: {
            "Accept": "application/json",
          },
          credentials: "same-origin", // ensures cookies/session are sent
        });

        if (response.ok) {
          const user = await response.json();
          setIsAuthenticated(true);
        } else {
          setIsAuthenticated(false);
        }
      } catch (err) {
        console.error("Error fetching /api/me:", err);
        setIsAuthenticated(false);
      }
    };

    checkUser();
  }, []);

  if (!isAuthenticated) return null;

  const handleDownload = async () => {
    if (
      !currentResultsState ||
      !currentResultsState.data ||
      !currentResultsState.data.hits
    ) {
      console.warn("No search results available.");
      return;
    }

    const recordIds = currentResultsState.data.hits.map((hit) => hit.id);
    console.log("Record IDs to download:", recordIds);

    const currentUrl = window.location.href;

    setDownloading(true);
    try {
      const response = await axiosWithCSRF.post(
        "/records/files-archive-all",
        { current_url: currentUrl },
        { responseType: "blob" } // Important for binary data!
      );

      const now = new Date();
      const pad = (n) => n.toString().padStart(2, "0");
      const timestamp = `${pad(now.getMonth() + 1)}-${pad(now.getDate())}-${now.getFullYear()}-${pad(now.getHours())}-${pad(now.getMinutes())}-${pad(now.getSeconds())}`;

      // Default filename
      let filenamePrefix = "all-records";

      // Check if URL contains 'communities'
      const current_url = window.location.href;
      const communitiesMatch = current_url.match(/\/communities\/([^/]+)/);
      if (communitiesMatch && communitiesMatch[1]) {
        filenamePrefix = communitiesMatch[1];  // Community name from URL
      }

      const finalFilename = `${filenamePrefix}-files-${timestamp}.zip`;

      // Create a blob and simulate download
      const blob = new Blob([response.data], { type: "application/zip" });
      const url = window.URL.createObjectURL(blob);
      const link = document.createElement("a");
      link.href = url;
      link.download = finalFilename;  // Default filename
      document.body.appendChild(link);
      link.click();
      link.remove();
      window.URL.revokeObjectURL(url);
    } catch (error) {
      console.error("Download failed:", error);
    } finally {
      setDownloading(false);
    }
  };

  return (
   <div>
    <Button
      fluid
      icon="download"
      content="Download All"
      onClick={handleDownload}
      className="mt-10"
      primary
    />
    {downloading && <p style={{ color: "green" }}>Preparing download, please wait...</p>}
   </div>
  );
};

export const DownloadAllButton = withState(DownloadAllButtonCmp);
